export const IAM_API_BASE_URL =
  import.meta.env.VITE_IAM_API_BASE_URL ?? "/api/iam";

export const BILLING_API_BASE_URL =
  import.meta.env.VITE_BILLING_API_BASE_URL ?? "/api/billing";

export const IAM_TENANT_SLUG =
  import.meta.env.VITE_IAM_TENANT_SLUG ?? "demo";

export const SUITE_URL =
  import.meta.env.VITE_SUITE_URL ?? "http://localhost:3000";

export function getSuiteLoginUrl(): string {
  return `${SUITE_URL.replace(/\/$/, "")}/login`;
}
